module.exports = __webpack_public_path__ + "img/previous.2f817e58.svg";